const countryNamesByLocale = new Map<string, string[]>();
const displayNamesByLocale = new Map<string, Intl.DisplayNames>();

function getDisplayNames(locale: string): Intl.DisplayNames {
  const cached = displayNamesByLocale.get(locale);
  if (cached) return cached;

  const displayNames = new Intl.DisplayNames([locale], { type: "region" });
  displayNamesByLocale.set(locale, displayNames);
  return displayNames;
}

export function getCountryName(code: string, locale = "en"): string | undefined {
  const normalized = code.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) return undefined;

  const name = getDisplayNames(locale).of(normalized);
  if (!name || name === normalized) return undefined;

  return name;
}

export function getCountryNames(locale = "en"): string[] {
  const cached = countryNamesByLocale.get(locale);
  if (cached) return cached;

  const displayNames = getDisplayNames(locale);
  const names = new Set<string>();

  for (let i = 65; i <= 90; i++) {
    for (let j = 65; j <= 90; j++) {
      const code = String.fromCharCode(i) + String.fromCharCode(j);
      const name = displayNames.of(code);

      if (name && name !== code) {
        names.add(name);
      }
    }
  }

  const sorted = Array.from(names).sort((a, b) => a.localeCompare(b, locale));
  countryNamesByLocale.set(locale, sorted);
  return sorted;
}
